import { useEffect, useState } from "react";
import { LeaveDay, useFerieApi } from "../Hooks/useFerieApi";
import Year from "./Year";
import { Box, Button, Grid, Stack } from "@mui/material";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { useIsAuthenticated } from "@azure/msal-react";
import InfoPanel from "./InfoPanel";
import LoginPanel from "./LoginPanel";
import config from '../Config/environments';
import ensoLogo from '../assets/Logo.svg';

const PoCalendar: React.FC = () => {
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const api = useFerieApi();
  const [isUser, setIsUser] = useState<boolean | undefined>(false);
  const [vacation, setVacation] = useState<LeaveDay[] | undefined>([]);
  const isAuthenticated = useIsAuthenticated();
  const [activityType, setActivityType] = useState<number>(config.holidayCode);
  const [userLoaded, setUserLoaded] = useState<boolean>(false);
  const [vacationLoaded, setVacationLoaded] = useState<boolean>(false);
  const handleVacationUpdate = (updatedVacation: LeaveDay[]) => {
    console.log("handleVacationUpdate called with:", updatedVacation);
    setVacation(updatedVacation);
  };
  useEffect(() => {
    if (isAuthenticated) {
      api.isUser().then((isUser) => {
        setIsUser(isUser);
        setUserLoaded(true);
      }).catch((error) => {
        console.error("Error calling isUser:", error);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  useEffect(() => {
    if (isUser) {
      setVacationLoaded(false);
      api.getVacation(year).then((vacation) => {
        setVacation(vacation);
        setVacationLoaded(true);
      }).catch((error) => {
        console.error("Error fetching vacation:", error);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUser, year]);

  return (
    <>
      <Stack>
        <Box sx={{
          display: { xs: 'block', md: 'block' },
          marginTop: 1,
          marginX: 1
        }}>
          <img src={ensoLogo} alt="Enso logo" style={{ width: "80px" }} />
        </Box>

        {/* Mobile: InfoPanel first, full width */}
        <Box sx={{
          display: { xs: 'block', md: 'none' },
          marginTop: 2,
        }}>
          <InfoPanel isUser={isUser} fullWidth={true} vacation={vacation} onActivityTypeUpdate={setActivityType} showButtons={true} doneLoading={userLoaded && vacationLoaded} />
        </Box>

          {/* Mobile: Navigation buttons below InfoPanel */}
        <Box sx={{
          display: { xs: 'flex', md: 'none' },
          justifyContent: 'center',
          marginTop: 2
        }}>
          <Grid container spacing={2} alignItems="center" justifyContent="center" sx={{ width: "auto" }}>
            <Button startIcon={<KeyboardDoubleArrowLeftIcon />} onClick={() => setYear(year - 1)} sx={{ color: '#6d4646' }}></Button>
            <Box sx={{ textAlign: "center", padding: 1, fontSize: "17pt", fontWeight: "bold", color: '#6d4646' }} >{year}</Box>
            <Button endIcon={<KeyboardDoubleArrowRightIcon />} onClick={() => setYear(year + 1)} sx={{ color: '#6d4646' }}></Button>
          </Grid>
        </Box>

        {/* Desktop: Original horizontal layout */}
        <Box sx={{
          display: { xs: 'none', md: 'flex' },
          minHeight: 80,
          marginTop: 2
        }}>

          <Box sx={{ height: 10, flex: 1 }} >
            {isAuthenticated && (
              <InfoPanel  isUser={isUser} fullWidth={false} vacation={vacation} onActivityTypeUpdate={setActivityType} showButtons={false} doneLoading={userLoaded && vacationLoaded} />
            )}
          </Box>

          <Grid container spacing={2} alignItems="center" justifyContent="center" sx={{ width: "auto" }}>
            <Button startIcon={<KeyboardDoubleArrowLeftIcon />} onClick={() => setYear(year - 1)} sx={{ color: '#6d4646' }}></Button>
            <Box sx={{ textAlign: "center", padding: 1, fontSize: "17pt", fontWeight: "bold", color: '#6d4646' }} >{year}</Box>
            <Button endIcon={<KeyboardDoubleArrowRightIcon />} onClick={() => setYear(year + 1)} sx={{ color: '#6d4646' }}></Button>
          </Grid>

          <Box sx={{ height: 50, flex: 1, display: 'flex', justifyContent: 'flex-end' }} >
            <LoginPanel />
          </Box>
        </Box>

        <Box sx={{
          position: "relative"
        }}>
          <Box sx={{ marginTop: 2, width: "100%" }}>
            <Year year={year} vacation={vacation} onVacationUpdate={handleVacationUpdate} activityType={activityType} />
          </Box>

          {!vacationLoaded && isAuthenticated && (
            <Box sx={{ position: "absolute", top: "0", left: "0", backgroundColor: "#C3A2A2", opacity: "0.5", width: "100vw", height: "100vh", color: '#6d4646' }}>
              <Box sx={{
                width: 100,
                height: 100,
                borderRadius: '50%',
                border: '4px solid #0E0E0E',
                borderTopColor: 'transparent',
                margin: "25% 50%",
                animation: 'spin 1s linear infinite',
                '@keyframes spin': {
                  '0%': { transform: 'rotate(0deg)' },
                  '100%': { transform: 'rotate(360deg)' }
                }
              }} />
            </Box>
          )}
        </Box>
      </Stack>
    </>
  );
};
export default PoCalendar;
